export const ABHA_FIELDS_NAMES = {
	SELECT_OPTION: 'getOption',
	ABHA_NUMBER: 'abhaNumber',
	ABHA_ADDRESS: 'abhaAddress',
	AADHAR_NUMBER: 'aadharNumber',
};

export const ABHA_OPTIONS = {
	GET_OPTIONS: [
		{ label: 'Aadhaar Number', value: 'Aadhaar Number' },
		{ label: 'ABHA Number', value: 'ABHA Number' },
		{ label: 'ABHA Address', value: 'ABHA Address' },
		{ label: 'Mobile Number', value: 'Mobile Number' },
		{ label: 'Scan and Share', value: 'Scan and Share' },
	],
};

export const ABHA_ERROR_MESSAGES = {
	aadharNumber: 'Aadhaar must be 12 digits',
	abhaNumber: 'ABHA Number must be 14 digits',
	abhaAddress1: "Please do not include '@abdm' in the ABHA Address — it will be added automatically.",
	abhaAddress2: "ABHA Address must be minimum 8 and maximum 18 characters excluding '@abdm'.",
	mobileNumber: 'Mobile number must be 10 digits and start with 6-9',
};

export const GENDER_OPTIONS = [
	{ label: 'M', value: 'Male' },
	{ label: 'F', value: 'Female' },
];

export const ABHA_LANGUAGE_OPTIONS = [
	{ label: 'English', value: 'English', code: 'en' },
	{ label: 'हिंदी', value: 'हिंदी', code: 'hi' },
	{ label: 'বাংলা', value: 'বাংলা', code: 'bn' },
	{ label: 'తెలుగు', value: 'తెలుగు', code: 'te' },
	{ label: 'मराठी', value: 'मराठी', code: 'mr' },
	{ label: 'தமிழ்', value: 'தமிழ்', code: 'ta' },
	{ label: 'اردو', value: 'اردو', code: 'ur' },
	{ label: 'ગુજરાતી', value: 'ગુજરાતી', code: 'gu' },
	{ label: 'ಕನ್ನಡ', value: 'ಕನ್ನಡ', code: 'kn' },
	{ label: 'മലയാളം', value: 'മലയാളം', code: 'ml' },
	{ label: 'ਪੰਜਾਬੀ', value: 'ਪੰਜਾਬੀ', code: 'pa' },
	{ label: 'ଓଡ଼ିଆ', value: 'ଓଡ଼ିଆ', code: 'or' },
	{ label: 'অসমীয়া', value: 'অসমীয়া', code: 'as' },
	{ label: 'کٲشُر', value: 'کٲشُر', code: 'ks' },
	{ label: 'मैथिली', value: 'मैथिली', code: 'mai' },
	{ label: 'संस्कृत', value: 'संस्कृत', code: 'sa' },
	{ label: 'कोंकणी', value: 'कोंकणी', code: 'kok' },
	{ label: 'बोड़ो', value: 'बोड़ो', code: 'bodo' },
	{ label: 'डोगरी', value: 'डोगरी', code: 'doi' },
	{ label: 'नेपाली', value: 'नेपाली', code: 'ne' },
	{ label: 'سنڌي', value: 'سنڌي', code: 'sd' },
	{ label: 'মৈতৈলোন', value: 'মৈতৈলোন', code: 'mni' },
];

export const ABHA_CONSENT_FORM_LANGUAGE_TEXT = {
	en: 'Are you sure you want to share your personal details to create an ABHA number?',
	hi: 'क्या आप सुनिश्चित हैं कि आप ABHA नंबर बनाने के लिए अपनी व्यक्तिगत जानकारी साझा करना चाहते हैं?',
	bn: 'আপনি কি নিশ্চিত যে আপনি ABHA নম্বর তৈরির জন্য আপনার ব্যক্তিগত তথ্য শেয়ার করতে চান?',
	te: 'ABHA నంబర్ సృష్టించడానికి మీ వ్యక్తిగత వివరాలను పంచుకోవాలని మీరు ఖచ్చితంగా అనుకుంటున్నారా?',
	mr: 'ABHA नंबर तयार करण्यासाठी तुमची वैयक्तिक माहिती सामायिक करायची आहे याची तुम्हाला खात्री आहे का?',
	ta: 'ABHA எண்ணை உருவாக்க உங்கள் சொந்த தகவல்களை பகிர விரும்புகிறீர்களா?',
	ur: 'کیا آپ ABHA نمبر بنانے کے لیے اپنی ذاتی تفصیلات شیئر کرنے کے بارے میں پُر یقین ہیں؟',
	gu: 'શું તમે ખાતરીપૂર્વક ABHA નંબર બનાવવા માટે તમારી અંગત માહિતી શેર કરવા માંગો છો?',
	kn: 'ABHA ಸಂಖ್ಯೆಯನ್ನು ಸೃಜಿಸಲು ನಿಮ್ಮ ವೈಯಕ್ತಿಕ ವಿವರಗಳನ್ನು ಹಂಚಿಕೊಳ್ಳಲು ನೀವು ಖಚಿತವಾಗಿದ್ದೀರಾ?',
	ml: 'ABHA നമ്പർ സൃഷ്ടിക്കാൻ നിങ്ങളുടെ വ്യക്തിഗത വിശദാംശങ്ങൾ പങ്കിടാൻ നിങ്ങൾ ഉറപ്പാണോ?',
	pa: 'ਕੀ ਤੁਸੀਂ ABHA ਨੰਬਰ ਬਣਾਉਣ ਲਈ ਆਪਣੀ ਨਿੱਜੀ ਜਾਣਕਾਰੀ ਸਾਂਝੀ ਕਰਨ ਲਈ ਯਕੀਨੀ ਹੋ?',
	or: 'ଆପଣ ନିଶ୍ଚିତ କି ABHA ନମ୍ବର ତିଆରି ପାଇଁ ଆପଣଙ୍କର ବ୍ୟକ୍ତିଗତ ବିବରଣୀ ସେୟାର କରିବେ?',
	as: 'আপুনি ABHA নম্বৰ সৃষ্টি কৰিবলৈ আপোনাৰ ব্যক্তিগত বিৱৰণ ভাগ-বতৰা কৰিবলৈ নিশ্চিতনে?',
	ks: 'کیا آپ ABHA نمبر بنانے کے لیے اپنی ذاتی تفصیلات شیئر کرنے کے لیے یقین رکھتے ہیں؟',
	mai: 'की अहां निश्चित छी जे ABHA नंबर बनेबाक लेल अहांक व्यक्तिगत जानकारी साझा करए चाहैत छी?',
	sa: 'किं भवतः निश्चयः अस्ति यत् ABHA संख्या निर्मातुं स्वीयं व्यक्तिगत विवरणं साझयितुं इच्छथ?',
	kok: 'तुमका खात्री आसा की ABHA नंबर तयार करपाक तुमच्या व्यक्तिगत तपशील शेअर करपाचें आसा?',
	bodo: 'ABHA नोंबर फोरनोर थाखारनि नोंथायनि गोनांनि खाथामनथि गोंथायनाय नाङोनाय?',
	doi: 'की तुसीं यकीन नाल अपनी निजी जानकारी ABHA नंबर बनान लेई साझी करना चाहंदे हो?',
	ne: 'के तपाईं ABHA नम्बर सिर्जना गर्न आफ्नो व्यक्तिगत विवरण साझा गर्न निश्चित हुनुहुन्छ?',
	sd: 'ڇا توهان کي يقين آهي ته توهان ABHA نمبر ٺاهڻ لاءِ پنهنجي ذاتي تفصيل شيئر ڪرڻ چاهيو ٿا؟',
	mni: 'ABHA নম্বৰ তৈরিকরণত নাংগা ব্যক্তিগত বিৱৰণ সেয়াৰ তৌ? নাং নিশ্চিত তৌ?',
};

export const ABHA_UPDATE_OPTIONS = [
	{ label: 'Select update option', value: '' },
	{ label: 'Update ABHA Address', value: 'abhaAddress' },
	// { label: 'Update Email', value: 'email' },
	{ label: 'Update Mobile Number', value: 'mobile' },
	{ label: 'Update Profile Picture', value: 'profilePicture' },
];

export const ABHA_VERIFICATION_OPTIONS = [
	{ label: 'Aadhaar Link Number', value: 'aadharLink' },
	{ label: 'ABHA Link Number', value: 'mobileLink' },
];

export const FORM_FIELDS_NAMES = {
	PROFILE_PICTURE: 'profilePicture',
	FIRSTNAME: 'firstName',
	MIDDLENAME: 'middleName',
	LASTNAME: 'lastName',
	DOB: 'dob',
	GENDER: 'gender',
	MARITAL_STATUS: 'maritalStatus',
	AADHAR_NUMBER: 'aadhar',
	TIMEZONE: 'timeZone',
	LANGUAGE: 'language',
	IS_PATIENT_AADHAR: 'isPatientsAadhar',
	MOBILE_NUMBER: 'mobileNumber',
	OTP: 'otp',
};
export const DETAILS_REVIEW_FIELDS_NAMES = {
	UPDATE_OPTION: 'updateOption',
};

export const GARDIAN_FIELDS_NAMES = {
	GUARDIAN_NAME: 'guardianName',
	RELATIONSHIP: 'relationWithPatient',
	GUARDIAN_AADHAR_NUMBER: 'guardianAadhar',
	PATIENT_DOB: 'patientsBirthTimestamp',
};

export const LANGUAGE_OPTIONS = [
	{ label: 'English', value: 'English' },
	{ label: 'Hindi', value: 'Hindi' },
	{ label: 'Other', value: 'Other' },
];

export const TIMEZONE_OPTIONS = [
	{ label: 'IST', value: 'IST' },
	{ label: 'PST', value: 'PST' },
	{ label: 'EST', value: 'EST' },
	{ label: 'CST', value: 'CST' },
	{ label: 'MST', value: 'MST' },
	{ label: 'AST', value: 'AST' },
	{ label: 'HST', value: 'HST' },
];

export const CONSENT_POINTS = {
	en: [
		`I hereby declare that: I am voluntarily sharing my Aadhaar Number / Virtual ID issued by the Unique Identification Authority of India ("UIDAI"), and my demographic information for the purpose of creating an Ayushman Bharat Health Account number ("ABHA number") and Ayushman Bharat Health Account address ("ABHA Address"). I authorize maestrostelehealth to use my Aadhaar number / Virtual ID for performing Aadhaar-based authentication with UIDAI as per the provisions of the Aadhaar (Targeted Delivery of Financial and other Subsidies, Benefits and Services) Act, 2016 for the aforesaid purpose. I understand that UIDAI will share my e-KYC details or response of "Yes" with maestrostelehealth upon successful authentication.`,
		`I intend to create Ayushman Bharat Health Account Number ("ABHA number") and Ayushman Bharat Health Account address ("ABHA Address") using documents other than Aadhaar. (Click here to proceed further)`,
		`I consent to the usage of my ABHA address and ABHA number for linking of my legacy (past) health records and those that will be generated during this encounter.`,
		`I authorize the sharing of all my health records with a healthcare doctor(s) for the purpose of providing healthcare services to me during this encounter.`,
		`I consent to the anonymization and subsequent use of my health records for public health purposes.`,
		`I maestrostelehealth confirm that I have duly informed and explained the beneficiary of the contents of consent for aforementioned purposes.`,
		`I have been explained about the consent as stated above and hereby provide my consent for the aforementioned purposes.`,
	],
	hi: [
		`मैं स्वेच्छा से अपना आधार नंबर / वर्चुअल आईडी और जनसांख्यिकीय जानकारी, जो भारतीय विशिष्ट पहचान प्राधिकरण ("यूआईडीएआई") द्वारा जारी की गई है, आयुष्मान भारत स्वास्थ्य खाता संख्या ("एबीएचए संख्या") और आयुष्मान भारत स्वास्थ्य खाता पता ("एबीएचए पता") बनाने के उद्देश्य से साझा कर रहा/रही हूँ। मैं maestrostelehealth को यूआईडीएआई के साथ आधार-आधारित प्रमाणीकरण करने की अनुमति देता/देती हूँ, जैसा कि आधार अधिनियम, 2016 में वर्णित है। मैं समझता/समझती हूँ कि प्रमाणीकरण सफल होने पर यूआईडीएआई maestrostelehealth को मेरी ई-केवाईसी जानकारी या "हाँ" की प्रतिक्रिया साझा करेगा।`,
		`मैं आधार के अलावा अन्य दस्तावेज़ों का उपयोग करके आयुष्मान भारत स्वास्थ्य खाता संख्या ("एबीएचए संख्या") और आयुष्मान भारत स्वास्थ्य खाता पता ("एबीएचए पता") बनाना चाहता/चाहती हूँ। (आगे बढ़ने के लिए यहां क्लिक करें)`,
		`मैं अपनी एबीएचए संख्या और एबीएचए पते के उपयोग की सहमति देता/देती हूँ ताकि मेरे पुराने और वर्तमान स्वास्थ्य रिकॉर्ड को लिंक किया जा सके।`,
		`मैं अपने सभी स्वास्थ्य रिकॉर्ड को स्वास्थ्य सेवा प्रदाता के साथ साझा करने की अनुमति देता/देती हूँ ताकि इस विज़िट के दौरान मुझे सेवाएं प्रदान की जा सकें।`,
		`मैं अपने स्वास्थ्य रिकॉर्ड के गुमनाम और सार्वजनिक स्वास्थ्य उद्देश्यों के लिए उपयोग की सहमति देता/देती हूँ।`,
		`मैं maestrostelehealth पुष्टि करता/करती हूँ कि मैंने लाभार्थी को इस सहमति की जानकारी दी है और उसे समझाया है।`,
		`मुझे उपरोक्त सहमति के बारे में समझाया गया है और मैं इन उद्देश्यों के लिए सहमति प्रदान करता/करती हूँ।`,
	],
	mr: [
		`मी माझा आधार क्रमांक / व्हर्च्युअल आयडी आणि माझी लोकसांख्यिक माहिती, जी UIDAI ने जारी केली आहे, स्वेच्छेने आयुष्मान भारत हेल्थ अकाउंट क्रमांक ("ABHA नंबर") आणि पत्ता तयार करण्यासाठी शेअर करत आहे. मी maestrostelehealth ला UIDAI सोबत आधार आधारित प्रमाणीकरण करण्यास परवानगी देतो, आधार अधिनियम 2016 नुसार. यशस्वी प्रमाणीकरणानंतर UIDAI माझी e-KYC माहिती किंवा "होय" अशी प्रतिक्रिया maestrostelehealth सोबत शेअर करेल याची मला जाणीव आहे.`,
		`मी आधार व्यतिरिक्त इतर कागदपत्रांचा वापर करून ABHA नंबर आणि पत्ता तयार करू इच्छितो/इच्छिते. (पुढे जाण्यासाठी येथे क्लिक करा)`,
		`मी माझ्या ABHA क्रमांक आणि पत्त्याचा वापर करून माझे जुने आणि सध्याचे आरोग्य रेकॉर्ड लिंक करण्यास संमती देतो/देते.`,
		`या भेटीदरम्यान मला आरोग्यसेवा देण्यासाठी माझ्या सर्व आरोग्य नोंदी आरोग्यसेवा पुरवठादारांसोबत शेअर करण्यास मी परवानगी देतो/देते.`,
		`सार्वजनिक आरोग्याच्या दृष्टीने माझ्या आरोग्य नोंदींचे गुप्तिकरण करून वापरण्यास मी संमती देतो/देते.`,
		`मी maestrostelehealth म्हणून हे नोंदवितो/नोंदविते की मी लाभार्थ्याला वरील संमतीची माहिती योग्य प्रकारे दिली आहे.`,
		`वरील संमती मला समजावून सांगण्यात आली आहे आणि मी ती स्वीकारत आहे.`,
	],
	bn: [
		`আমি স্বেচ্ছায় আমার আধার নম্বর / ভার্চুয়াল আইডি এবং আমার ডেমোগ্রাফিক তথ্য, যা UIDAI দ্বারা জারি করা হয়েছে, আয়ুষ্মান ভারত হেলথ অ্যাকাউন্ট নম্বর ("ABHA নম্বর") এবং অ্যাকাউন্ট ঠিকানা ("ABHA ঠিকানা") তৈরির উদ্দেশ্যে শেয়ার করছি। আমি maestrostelehealth কে UIDAI এর সঙ্গে আধার-ভিত্তিক প্রমাণীকরণ করতে অনুমতি দিচ্ছি, আধার আইন ২০১৬ অনুযায়ী। আমি বুঝি সফল প্রমাণীকরণের পরে UIDAI আমার e-KYC বা "হ্যাঁ" প্রতিক্রিয়া maestrostelehealth এর সঙ্গে শেয়ার করবে।`,
		`আমি আধার ছাড়া অন্যান্য ডকুমেন্ট ব্যবহার করে ABHA নম্বর এবং ঠিকানা তৈরি করতে চাই। (আগে বাড়াতে এখানে ক্লিক করুন)`,
		`আমি আমার ABHA নম্বর এবং ঠিকানার ব্যবহার করে আমার পুরোনো ও বর্তমান স্বাস্থ্য রেকর্ড যুক্ত করতে সম্মতি দিচ্ছি।`,
		`এই সাক্ষাতে স্বাস্থ্যসেবা প্রদানের উদ্দেশ্যে আমি আমার সব স্বাস্থ্য রেকর্ড স্বাস্থ্যসেবা প্রদানকারীদের সঙ্গে শেয়ার করতে অনুমতি দিচ্ছি।`,
		`জনস্বাস্থ্য বিষয়ক উদ্দেশ্যে আমি আমার স্বাস্থ্য রেকর্ড অজ্ঞাত করে ব্যবহারে সম্মতি দিচ্ছি।`,
		`আমি maestrostelehealth নিশ্চিত করছি যে আমি উপকারভোগীকে এই সম্মতির বিষয়টি সম্পূর্ণরূপে ব্যাখ্যা করেছি।`,
		`উপরোক্ত সম্মতি ব্যাখ্যা করা হয়েছে এবং আমি উপরে উল্লিখিত উদ্দেশ্যে সম্মতি দিচ্ছি।`,
	],
	te: [
		`నేను నా ఆధార్ నంబర్ / వర్చువల్ ఐడీ మరియు జనసాంఖ్యిక సమాచారం (UIDAI ద్వారా జారీ చేయబడిన) స్వచ్ఛందంగా Ayushman Bharat Health Account (ABHA) నంబర్ మరియు అడ్రస్ సృష్టించే ఉద్దేశ్యంతో పంచుకుంటున్నాను. UIDAIతో ఆధార్ ఆధారిత ధృవీకరణ చేయడానికి maestrostelehealthకి అనుమతిస్తున్నాను. ఆధార్ చట్టం, 2016 ప్రకారం ఇది జరుగుతుంది. ధృవీకరణ విజయవంతమైన తర్వాత UIDAI నా e-KYC వివరాలు లేదా "అవును" అనే స్పందనను maestrostelehealthకి షేర్ చేస్తుంది.`,
		`నేను ఆధార్ కాకుండా ఇతర పత్రాలతో ABHA నంబర్ మరియు అడ్రస్ సృష్టించాలనుకుంటున్నాను. (ముందుకు సాగేందుకు ఇక్కడ క్లిక్ చేయండి)`,
		`నా ABHA నంబర్ మరియు అడ్రస్ వాడి నా పాత మరియు తాజా ఆరోగ్య రికార్డులను అనుసంధానం చేయడానికి నేను సమ్మతిస్తున్నాను.`,
		`ఈ పరామర్శ సమయంలో నాకు ఆరోగ్య సేవలు అందించేందుకు నా అన్ని ఆరోగ్య రికార్డులను ఆరోగ్య సంరక్షణ సంస్థలతో పంచుకునేందుకు అనుమతిస్తున్నాను.`,
		`సార్వజనిన ఆరోగ్య ప్రయోజనాల కోసం నా ఆరోగ్య రికార్డులను అజ్ఞాత రూపంలో వాడేందుకు నేను సమ్మతిస్తున్నాను.`,
		`నేను maestrostelehealthగా నిబంధనలను లబ్ధిదారునికి పూర్తిగా వివరించినట్లు ధృవీకరిస్తున్నాను.`,
		`పైన పేర్కొన్న సమ్మతి నాకు వివరించబడింది మరియు ఈ ప్రయోజనాల కోసం నేను సమ్మతిస్తున్నాను.`,
	],
};

export const CONSENT_LINE_TEMPLATE = {
	en: {
		before: 'I',
		after: 'hereby declare that I have read and understood the contents of this consent form and provide my consent.',
	},
	hi: {
		before: 'मैं',
		after: 'यह घोषणा करता/करती हूँ कि मैंने इस सहमति पत्र की सामग्री को पढ़ लिया है और समझ लिया है तथा उपर्युक्त उद्देश्यों के लिए अपनी सहमति देता/देती हूँ।',
	},
	mr: {
		before: 'मी',
		after: 'या सहमती पत्रातील मजकूर वाचला असून समजून घेतला आहे आणि मी माझी सहमती देत आहे, असे घोषित करतो/करते.',
	},
	bn: {
		before: 'আমি',
		after: 'এই সম্মতি ফর্মের বিষয়বস্তু পড়েছি এবং বুঝেছি এবং আমার সম্মতি প্রদান করছি বলে ঘোষণা করছি।',
	},
	ta: {
		before: 'நான்',
		after: 'இந்த ஒப்புதல் படிவத்தின் உள்ளடக்கங்களை வாசித்து புரிந்துகொண்டேன் என்றும் ஒப்புதலை அளிக்கிறேன் என்றும் உறுதிப்படுத்துகிறேன்.',
	},
};
